import { KintsuSMonAbi } from '../abis/kintsu'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Kintsu sMON reader.
 *
 * Two calls on the sMON contract: `totalPooled()` (total MON staked) and
 * `totalShares()` (total sMON). The 1e18-scaled exchange rate is
 * `totalPooled * 1e18 / totalShares` — matches the contract's own
 * `convertToAssets(uint96)` (which takes a non-standard uint96 input, so
 * we derive from totals instead of calling it directly).
 */
export const readerKintsuSMon = (entry: LstRegistryEntry): LstReader => ({
  calls: [
    { address: entry.address, name: 'totalPooled', params: [] },
    { address: entry.address, name: 'totalShares', params: [] },
  ],
  abis: [KintsuSMonAbi, KintsuSMonAbi],
  parse: ([pooled, shares]) => {
    const totalAssets = toBigInt(pooled)
    const totalSupply = toBigInt(shares)
    if (totalAssets === undefined || totalSupply === undefined) return undefined
    const exchangeRate =
      totalSupply > 0n ? (totalAssets * ONE_E18) / totalSupply : ONE_E18
    return { totalAssets, totalSupply, exchangeRate }
  },
})
